  
<app-admin-side-bar></app-admin-side-bar>

<!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-dark">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" appRemoveOverlayDirective data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a class="nav-link">Home</a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a class="nav-link">Invoices</a>
    </li>
  </ul>

  <!-- Right navbar links -->
  <ul class="navbar-nav ml-auto">
    <!-- <li class="nav-item dropdown">
      <a><app-admin-test-mode></app-admin-test-mode> </a>
    </li> -->
  </ul>
</nav>
<!-- /.navbar -->


<div class="content-wrapper">

  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Invoices</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a>Home</a></li>
            <li class="breadcrumb-item active">Invoices</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <div class="container-fluid" style="padding: 15px;">
    <div class="row">
      <section *ngIf="Role==1" class="col-md-12">
        <!-- <button class="btnDef" (click)="exportData()">Export CSV</button> &nbsp;&nbsp;
        <button class="btnDef" (click)="exportDataPDF()">Export PDF</button> -->

      </section>
    </div>
    <br>
    <div class="row">
      
      <div class="col-md-2 col-sm-3">
        <select class="form-control" (change)="onSelectChange($event.target)">
          <option>Select</option>
          <option value="1">Today</option>
          <option value="2">Yesterday</option>
          <option value="3">This week</option>
          <option value="4">Last Week</option>
          <option value="5">This Month</option>
          <option value="6">Last Month</option>
          <option value="7">Custom</option>
        </select>
      </div>

      <div class="col-md-3 col-sm-5" *ngIf="boolCustom">
        <mat-form-field style="height: 50px;" class="example-full-width mb-3">
          <mat-date-range-input style="margin-top: -12px;" [rangePicker]="picker">
            <input style="position: absolute; top:0px" matStartDate placeholder="Start Date & Time" [(ngModel)]="startDate">
            <input matEndDate placeholder="End Date & Time" [(ngModel)]="endDate">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="col-md-3 pull-right" *ngIf="Role==1">
        <mat-form-field style="height: 50px;" appearance="fill">
          <mat-select style="position: absolute; top: 0px" #retailerSelect [placeholder]="'Select Retailer'" [(ngModel)]="selectedRetailer">
            <!-- <mat-option>
              <input class="filterTextBox" matInput placeholder="Search retailer" [(ngModel)]="filterRetailer" (keyup)="filterRetailers()" autocomplete="off">
            </mat-option> -->
            <mat-option [value]="0">Select All</mat-option>
            <mat-option *ngFor="let retailer of filteredRetailers" [value]="retailer.id">
              {{ retailer.fullName }}
            </mat-option>
          </mat-select>
          <button style="width: 10% !important; border: 0px;" mat-button matSuffix (click)="retailerSelect.open()">
          </button>
        </mat-form-field>
        <!-- <mat-form-field style="height: 50px;" appearance="fill">
          <mat-select style="position: absolute; top:0px" #retailerSelect [placeholder]="'Select Retailer'">
            <input class="filterTextBox" matInput placeholder="'Search retailer'" [(ngModel)]="filterRetailer"
            (keyup)="filterRetailers($event.target)" autocomplete="off">
            <mat-option [value]="null">Select Retailer</mat-option>
            <mat-option *ngFor="let retailer of Retailers" [value]="retailer.id">
              {{ retailer.fullName }}
            </mat-option>
          </mat-select>
          <button style="width: 10% !important; border: 0px;" mat-button matSuffix (click)="retailerSelect.open()">
          </button>
        </mat-form-field> -->
      </div>
      <div class="col-md-1 col-sm-3 mx-2">
        <button type="submit" class="btn btn-dark" (click)="Filter()">Search</button>
      </div>
    </div>

    <div class="container mt-5">
      <div class="row">
          <div class="col-md-4 col-xl-3">
              <div class="card bg-c-blue order-card">
                  <div class="card-block">
                      <h2 class="m-b-20">Actual Amount</h2>
                      <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" >{{actualAmount}}<span ></span></h2>
                  </div>
              </div>
          </div>
          <div class="col-md-4 col-xl-3">
              <div class="card bg-c-green order-card">
                  <div class="card-block">
                      <h2 class="m-b-20">Paid</h2>
                      <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" >{{paid}} <span ></span></h2>
                  </div>
              </div>
          </div>
          <div class="col-md-4 col-xl-3">
              <div class="card bg-c-yellow order-card">
                  <div class="card-block">
                      <h2 class="m-b-20">UnPaid</h2>
                      <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" >{{Unpaid}}<span  ></span></h2>

                  </div>
              </div>
          </div>
          <div class="col-md-4 col-xl-3" >
              <div class="card bg-c-pink order-card">
                  <div class="card-block">
                      <h2 class="m-b-20">Total</h2>
                      <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" >{{Total}}<span  ></span></h2>
                  </div>
              </div>
          </div>
    </div>
  </div>
  <div class="row">
    <div class="container">
      <section *ngIf="Role==1" class="col-md-12 pull-right mt-2 mb-1" >
        <button class="btnDef" (click)="exportData()">Export CSV</button> &nbsp;&nbsp;
        <button class="btnDef" (click)="exportDataPDF()">Export PDF</button>
  
      </section>
    </div>
  </div>
    <div class="row ">
      <section class="col-md-12 mt-2">

        <div class="card">

          <!-- /.card-header -->
          <div class="card-body">

            <div class="row">
              <div class="col-5"></div>
              <div class="col-2">
                <div *ngIf="loader==true">
                  <app-loader style="text-align: center;"></app-loader>
                </div>
              </div>
              <div class="col-5"></div>
            </div>
   
            <table *ngIf="loader==false" id="example2" class="table table-bordered table-hover table-responsive">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Retailer Name</th>
                
                  <th>StartDate</th>
                  <th>EndDate</th>
                  <th>Actual Amount</th>
                  <th>Plan</th>
                  <th>Paid</th>
                  <th>Unpaid</th>
                  <th>Total</th>
                  <th>Action</th>
                  <th *ngIf="Role==1">Payment Action</th>
                </tr>
              </thead>
              <tbody *ngFor="let invoice of invoices; let i = index;">
                <tr>
                  <td>{{invoice.id}}</td>
                  <td>{{invoice.retailer}}</td>
                 
                  <td>{{invoice.startDate}}</td>
                  <td>{{invoice.endDate}}</td>
                  <td>{{invoice.actualAmount}}</td>
                  <td>{{invoice.retailerPlanType}}</td>
                  <td>{{invoice.paidAmount}}</td>
                  <td>{{invoice.unPaidAmount}}</td>
                  <td>{{invoice.totalAmount}}</td>
                  <td><button class="btn btn-light" (click)="PrintRecipt(invoice.invoiceNumber)"><i class="fa fa-file-text-o"></i> Download</button></td>
                 
                  <td *ngIf="Role == 1 && isPostPaid(invoice.retailerPlanType)">
                    <input 
                      [disabled]="invoice.unPaidAmount === 0" 
                      value="{{invoice.unPaidAmount}}" 
                      #unpaidamount
                    />
                    <button 
                      class="bnn btn-danger" 
                      type="button" 
                      (click)="UpdateInvoice(unpaidamount.value, invoice.id, invoice.retailerId, invoice.invoiceNumber, invoice.unPaidAmount)" 
                      [disabled]="invoice.unPaidAmount === 0"
                      [class.disabled]="invoice.unPaidAmount === 0" 
                    >
                      Submit
                    </button>
                  </td>
                  
                 
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center my-3" *ngIf="totalItems > 0">
            <app-pager [totalCount]="totalItems" [pageSize]="10" (pageChanged)="onPageChanged($event)"></app-pager>
          </div>

          <!-- /.card-body -->
        </div>

      </section>
    </div>
  </div>


</div>

   


